export default __webpack_public_path__ + "static/media/icon-caretDown.a13baeb1.svg";